const sortByPosition = (arr: any) => {
  return arr.sort((a, b) => {
    const positionA = parseInt(a.position.split(' ')[0]);
    const positionB = parseInt(b.position.split(' ')[0]);
    return positionA - positionB;
  });
};
const pageViewPromoAnother = (params?: any, label?: any) => {
  if (params && params.length > 0) {
    if (typeof window !== 'undefined') {
      (window as any)?.dataLayer?.push({
        event: 'promotionView',
        eventCategory: 'ecommerce promotion',
        eventLabel: label || `promo terkait`,
        ecommerce: {
          promoView: {
            promotions: sortByPosition(params),
          },
        },
      });
    }
  }
};
export default pageViewPromoAnother;
